import { useCallback, useEffect } from 'react'
import { useLogEvent } from './useLogEvent'
import { MINUTES } from '@sequencehq/utils/dates'
import { apiQueryClient } from 'features/api/apiQueryClient'

const QUERY_CACHE_LOGGING_INTERVAL = 10 * MINUTES

export const useLogQueryCacheSize = () => {
  const { logEvent } = useLogEvent()

  const logQueryCacheSize = useCallback(() => {
    logEvent({
      eventName: 'query_cache_size',
      metadata: {
        totalEntries: apiQueryClient.getQueryCache().getAll().length
      }
    })
  }, [logEvent])

  useEffect(() => {
    const interval = setInterval(
      logQueryCacheSize,
      QUERY_CACHE_LOGGING_INTERVAL
    )
    return () => clearInterval(interval)
  }, [logQueryCacheSize])
}
